import Isotope from 'isotope-layout';
(function(win,doc){
  const caseStudies = {
    nav: doc.querySelector('#case-nav'),
    grid: doc.querySelector('.section-3 .container'),
    btn: doc.getElementById('load-more'),
    sameHeight: ['.section-2 .wrap','.section-3 .next-story-text'],
    counter: 6,
    init(){
      this.isotopeInit();
      this.loadMoreInit();
      this.addListeners();
      this.makeCardsSameHeight(this.sameHeight);
      this.refreshLayout();
    },
    isotopeInit(){
      win.iso = new Isotope(this.grid, {
        itemSelector: '.cardParent',
        layoutMode: 'fitRows',
        transitionDuration: 0
      })
    },
    loadMoreInit(){
      // reset counter hide all filtered cards
      this.counter = 6; //reset counter
      iso.filteredItems.map( item => item.element.hidden = true ); //hide all filtered items
      this.showTheseCards();
    },
    addListeners(){
      //nav clicks
      this.nav.addEventListener('click',(e) => {
        e.preventDefault;
        if(!e.target.classList.contains('dropdown-button')) this.filterCards(e); 
      });
      // load more btn clicks
      this.btn.addEventListener('click', (e) => this.showTheseCards(3));
      // window resize
      win.addEventListener('resize', (e) => this.refreshLayout());
    },
    filterCards(e){
      const type = e.target.dataset.type.toLowerCase();
      const filter = type !== '.all' ? `${type}` : '*';
      iso.arrange({ filter });
      this.addNavActiveClass(type);
      this.loadMoreInit();
    },
    makeCardsSameHeight(elms){
      Array.from(elms, el => makeSameHeight(el,true, () => iso.layout()))
    },
    addNavActiveClass(type){
      // add/remove the active class in the cards nav
      Array.from(this.nav.querySelectorAll('.tab'), tab => tab.classList.remove('active'));
      Array.from(this.nav.querySelectorAll(`a[data-type="${type}"]`), link => link.parentNode.classList.add('active'));
    },
    showTheseCards(num = 0){
      //show only 'num' mount of filtered cards
      this.counter += num; 
      iso.filteredItems.slice(0, this.counter).map(item => item.element.hidden = false); 
      this.hideShowBtn();
      win.dispatchEvent(new Event('resize')); //trigger resize to update makeSameHeight()
      this.refreshLayout() //refresh layout
    },
    hideShowBtn(){
      //hide btn when no more filtered cards to show
      this.counter >= iso.filteredItems.length ? this.btn.classList.remove('active') : this.btn.classList.add('active');
    },
    refreshLayout(){
      iso.layout();
    }
  }
  // start the show
  doc.addEventListener('DOMContentLoaded', () => caseStudies.init())
})(window,document)




